import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { Menu, MenuItem, ProSidebar, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import AppsCentreLogo from '../../images/sidebar-appscentre.svg';
import BulletinBoardLogo from '../../images/sidebar-bulletinboard.svg';
import HomeLogo from '../../images/sidebar-home.svg';
import ReportLogo from '../../images/sidebar-report.svg';
import InfoHubLogo from '../../images/sidebar-infohub.svg';
import SettingsLogo from '../../images/sidebar-settings.svg';
import SignoutButton from '../../images/signout-btn.svg';
import GrievanceLogo from '../../images/sidebar-grievance.png';
import ResignationLogo from '../../images/sidebar-resignation.png'
// import WorkerPerformanceBtn from '../../images/worker_performance_grading.png'
import WorkerPerformanceBtn from '../../images/worker_performance_grading.png'

const SignOut = styled.div`
  width: 15rem;
  margin: 30px auto;
`;

const SidebarContent = (props) => {
  const [showAll, setShowAll] = useState(false)
  const [showBulletin, setShowBulletin] = useState(false)
  const [showInfoHub, setShowInfoHub] = useState(false)
  const [showGrievance, setShowGrievance] = useState(false)
  const [showReport, setShowReport] = useState(false)
  const [showSettings, setShowSettings] = useState(false)
  const [showResignation, setShowResignation] = useState(false)
  const [showWorkerPerformanceGrading, setShowWorkerPerformanceGrading] = useState(false)

  useEffect(() => {
    if (props.loginList) {
      const loginListFromParent = props.loginList;
      console.log("props.loginList = ",props.loginList)

      const showAll = loginListFromParent.some((item) =>
        (item.permissionName.includes("Admin Role") && item.permissionType.includes("view"))
      )

      const showBulletin = loginListFromParent.some((item) =>
        (item.permissionName.includes("Bulletin Board") && item.permissionType.includes("view"))
      )

      const showInfoHub = loginListFromParent.some((item) =>
        (item.permissionName.includes("Info Hub") && item.permissionType.includes("view"))
      )

      const showReport = loginListFromParent.some((item) =>
        (item.permissionName.includes("Report") && item.permissionType.includes("view"))
      )

      const showResignation = loginListFromParent.some((item) =>
          (item.permissionName.includes("Resignation") && item.permissionType.includes("view"))
      )

      const showWorkerPerformanceGrading = loginListFromParent.some((item) =>
          (item.permissionName.includes("Worker Performance Grading") && item.permissionType.includes("view"))
      )

      const showSettings = loginListFromParent.some((item) =>
        (item.permissionName.includes("Create Bus Driver Account") && item.permissionType.includes("view"))
        ||
        (item.permissionName.includes("Reset Phone Number") && item.permissionType.includes("view"))
        ||
        (item.permissionName.includes("Reset Password") && item.permissionType.includes("view"))
        ||
        (item.permissionName.includes("Grievance Setting") && item.permissionType.includes("view"))
      )

      if (loginListFromParent) {
        setShowAll(showAll)
        setShowBulletin(showBulletin)
        setShowInfoHub(showInfoHub)
        setShowReport(showReport)
        setShowSettings(showSettings)
        setShowResignation(showResignation)
        setShowWorkerPerformanceGrading(showWorkerPerformanceGrading)
      }
    }

  }, [props.loginList])

  useEffect(() => {
    if (props.grievancePermission) {
      const grievancePermissionFromParent = props.grievancePermission;
      
      if (grievancePermissionFromParent == 1) {
        setShowGrievance(true);
      }
    }

  }, [props.grievancePermission])

  async function signOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  const location = useLocation();
  
  return (
    <ProSidebar>
      <Menu iconShape="circle" style={{ fontSize: '27px'}}>
        <MenuItem className={`${location.pathname === '/' ? 'sidebar-menu active' : ''}`} icon={<img src={HomeLogo} className='sidebar-menu-logo' alt='' />}>
          Home
          <Link to="/" />
        </MenuItem>
        <SubMenu title="Apps Centre" className='sidebar-menu-appscentre' icon={<img src={AppsCentreLogo} className='sidebar-menu-logo' alt='' />}>
          { (showAll || showBulletin) &&
          <MenuItem className={`${location.pathname.includes('/bulletinboard') ? 'sidebar-menu active' : ''}`} icon={<img src={BulletinBoardLogo} className='sidebar-menu-logo' alt='' />}>Bulletin Board<Link to="/bulletinboard" /></MenuItem>
          }
          { (showAll || showInfoHub) &&
          <MenuItem className={`${location.pathname === '/infohub' ? 'sidebar-menu active' : ''}`} icon={<img src={InfoHubLogo} className='sidebar-menu-logo' alt='' />}>Info Hub<Link to="/infohub" /></MenuItem>
          }
          { showGrievance &&
          <MenuItem className={`${location.pathname.includes('/grievance') ? 'sidebar-menu active' : ''}`} icon={<img src={GrievanceLogo} className='sidebar-menu-logo' alt='' />}>Grievance<Link to="/grievance" /></MenuItem>
          }
          { (showAll || showResignation) &&
          <MenuItem className={`${location.pathname.includes('/resignation') ? 'sidebar-menu active' : ''}`} icon={<img src={ResignationLogo} className='sidebar-menu-logo' alt='' />}>Resignation<Link to="/resignation" /></MenuItem>
          }
          { (showWorkerPerformanceGrading) &&
          <MenuItem className={`${location.pathname.includes('/workerPerformanceGrade') ? 'sidebar-menu active' : ''}`} icon={<img src={WorkerPerformanceBtn} className='sidebar-menu-logo' alt='' />}>Worker Performance Grading<Link to="/workerPerformanceGrade" loginList={props.loginList}/></MenuItem>
          }
          {/* { (showAll || showInfoHub) &&
          <SubMenu title='Info Hub' icon={<img src={InfoHubLogo} className='sidebar-menu-logo' alt='' />}>
            <MenuItem className={`${location.pathname === '/infohub/folder' ? 'sidebar-menu active' : ''}`} icon={<img src={FolderLogo} className='sidebar-menu-logo' alt='' />}>View Folder List<Link to="/infohub/folder" /></MenuItem>
            <MenuItem className={`${location.pathname === '/infohub' ? 'sidebar-menu active' : ''}`} icon={<img src={InfoHubLogo} className='sidebar-menu-logo' alt='' />}>View Info Hub<Link to="/infohub" /></MenuItem>
          </SubMenu>
          } */}

          {/* { showAll &&
          <MenuItem icon={<img src={SettingsLogo} className='sidebar-menu-logo' alt='' />}>
            Reports
            <Link to="/reports" />
          </MenuItem>
          } */}
        </SubMenu>
        { (showAll || showReport) &&
        <MenuItem className={`${location.pathname.includes('/reports') ? 'sidebar-menu active' : ''}`} icon={<img src={ReportLogo} className='sidebar-menu-logo' alt='' />}>
          Reports
          <Link to="/reports" />
        </MenuItem>
        }
        { (showAll || showSettings) &&
        <MenuItem className={`${location.pathname.includes('/settings') ? 'sidebar-menu active' : ''}`} icon={<img src={SettingsLogo} className='sidebar-menu-logo' alt='' />}>
          Settings
          <Link to="/settings" />
        </MenuItem>
        }
      </Menu>
      <SignOut>
          <img src={SignoutButton} onClick={signOut} className='sidebar-signout-btn' alt='' />
      </SignOut>
    </ProSidebar>
  )
}

export default SidebarContent;